import { useTheme } from "@mui/material";
import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

export const DataOS: React.FC<SvgIconProps> = (props) => {
  const theme = useTheme();

  return (
    <SvgIcon {...props} viewBox="0 0 18 18">
      <path
        d="M17 13.4444V4.55556C17 2.62844 13.337 1 9 1C4.663 1 1 2.62844 1 4.55556V13.4444C1 15.3716 4.663 17 9 17C13.337 17 17 15.3716 17 13.4444ZM9 2.77778C12.691 2.77778 14.931 4.11733 15 4.55022C14.931 4.99378 12.691 6.33333 9 6.33333C5.309 6.33333 3.069 4.99378 3 4.56089C3.069 4.11733 5.309 2.77778 9 2.77778ZM3 6.87289C4.479 7.62578 6.637 8.11111 9 8.11111C11.363 8.11111 13.521 7.62578 15 6.87289V8.99467C14.931 9.43822 12.691 10.7778 9 10.7778C5.309 10.7778 3.069 9.43822 3 9V6.87289ZM3 13.4444V11.3173C4.479 12.0702 6.637 12.5556 9 12.5556C11.363 12.5556 13.521 12.0702 15 11.3173V13.4391C14.931 13.8827 12.691 15.2222 9 15.2222C5.309 15.2222 3.069 13.8827 3 13.4444Z"
        fill={theme.palette.brandedTypography.textColor}
      />
    </SvgIcon>
  );
};

export default DataOS;
